import { path, invertObj } from "ramda";
import { getHideCompText } from "../helpers";
import { yearsExperienceMap } from "../../PostJob/withAddJob";

const yearsExperience = invertObj(yearsExperienceMap);

export default (job, isEditOrCopy) => {
  return {
    id: job.jobId,
    offices: job.offices,
    applicantGroup: job.applicant_group,
    jobCategory: job.job_category,
    jobTitle: job.jobTitle,
    employmentType: job.employment_type,
    yearsExperience: yearsExperience[job.years_experience]
      ? yearsExperience[job.years_experience]
      : job.years_experience,
    submissionDeadline: job.submission_deadline,
    baseCompensation: path(["base_compensation", "value"], job),
    baseCompensationMax: path(["base_compensation_max", "value"], job),
    additionalPGAEducation: job.additional_pga_education,
    paySchedule: job.pay_schedule,
    additionalIncome: job.additional_income,
    totalCompensation: path(["total_compensation", "value"], job),
    contact: {
      name: job.job_contact_name,
      title: job.job_contact_title,
      email: job.job_contact_email,
      phone: job.job_contact_phone,
    },
    education: job.education,
    applyVia: job.apply_via,
    website: job.external_job_url,
    overview: job.overview,
    experienceRequired: job.experience_required,
    responsibilities: job.responsibilities,
    benefits: job.benefits,
    termsOfServiceAgreement: job.tos,
    currentStep: job.current_step,
    createdAt: job.created,
    publishedAt: job.mgmt_job_go_live_datetime,
    facilities: job.facilities,
    otherSections: job.other_sections,
    otherStates: job.other_states,
    reviewRequestSent: job.review_request_sent,
    hideCompensation: isEditOrCopy
      ? getHideCompText(job.hide_compensation_from_job_board) // return label value for job form
      : job.hide_compensation_from_job_board, // return boolean value
  };
};
